import * as React from "react";
const SvgPrformance = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 10.911c1.165 0 2.11-.975 2.11-2.177 0-1.203-.945-2.178-2.11-2.178s-2.11.975-2.11 2.178.945 2.177 2.11 2.177"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M23.25 3.653h-1.406V1.476a.74.74 0 0 0-.206-.513.7.7 0 0 0-.497-.213.7.7 0 0 0-.498.213.74.74 0 0 0-.206.513v2.177H3.564V1.476a.74.74 0 0 0-.206-.513.7.7 0 0 0-.498-.213.7.7 0 0 0-.497.213.74.74 0 0 0-.206.513v2.177H.75v1.452h1.406v2.177c0 .193.074.377.206.513.132.137.31.213.497.213a.7.7 0 0 0 .498-.213.74.74 0 0 0 .205-.513V5.105h16.876v2.177c0 .193.074.377.205.513a.692.692 0 0 0 .994 0 .74.74 0 0 0 .207-.513V5.105h1.406z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m15.019 13.278 3.83-6.722H16.73l-3.225 5.081h-3.012l-3.225-5.08H5.152l3.83 6.721q.084.143.206.253v3.26l-1.919.304c-.248.04-.475.17-.64.367a1.1 1.1 0 0 0-.254.707v5.081h1.758l.351-4.146L12 18.545l3.516.558.351 4.147h1.758v-5.08c0-.26-.09-.512-.254-.71a1.05 1.05 0 0 0-.64-.366l-1.919-.304v-3.26q.121-.109.207-.252"
  }
));
export default SvgPrformance;
